var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'rate d-flex flex-row',
    {
      'rate--disabled': _vm.disabled,
      'rate--lg': _vm.size === 'lg'
    }
  ]},[_vm._l((5),function(n){return _c('b-icon',{key:n,class:{
      active: Math.floor(_vm.activeValue) >= n
    },attrs:{"icon":"star-fill"},on:{"click":function($event){return _vm.rate(n)},"mouseover":function($event){return _vm.setHoverValue(n)},"mouseleave":function($event){return _vm.setHoverValue(null)}}})}),(_vm.hasLabel)?_c('p',[_vm._v(_vm._s(parseFloat(_vm.value)))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }